var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimalScientist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#EDFAF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 29H25.6667",
    stroke: "#00A651",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32.3333H31.5",
    stroke: "#00A651",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6668 32.3334C27.2139 32.3334 28.6977 31.7188 29.7916 30.6249C30.8856 29.5309 31.5002 28.0472 31.5002 26.5001C31.5002 24.953 30.8856 23.4693 29.7916 22.3753C28.6977 21.2813 27.2139 20.6667 25.6668 20.6667H24.8335",
    stroke: "#00A651",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 25.6667H23.1667",
    stroke: "#00A651",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5002 24C21.0581 24 20.6342 23.8244 20.3217 23.5118C20.0091 23.1993 19.8335 22.7754 19.8335 22.3333V19H24.8335V22.3333C24.8335 22.7754 24.6579 23.1993 24.3453 23.5118C24.0328 23.8244 23.6089 24 23.1668 24H21.5002Z",
    stroke: "#00A651",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 19.0001V16.5001C23.9998 16.2791 23.912 16.0671 23.7558 15.9108C23.5995 15.7545 23.3875 15.6667 23.1665 15.6667H21.4998C21.2788 15.6667 21.0669 15.7545 20.9106 15.9108C20.7543 16.0671 20.6665 16.2791 20.6665 16.5001V19.0001",
    stroke: "#00A651",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimalScientist);
export default __webpack_public_path__ + "static/media/animalScientist.f792e882e8d05eea86affc6c65f54a53.svg";
export { ForwardRef as ReactComponent };